import { FocusCss } from '@tvg/fuse-utils';
import styled from 'styled-components';
import StyledTappableArea from '../../fuse-tappable-area/src/tappablearea';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { stylesConfig } from './config';

const { input, radioLabelBefore } = stylesConfig;

const StyledRadio = styled.div.attrs({
	className: 'fuse-radio',
})`
	${({ fullWidth, marginBottom, marginRight }) => `
		align-items: center;
		display: inline-flex;
		margin-bottom: ${marginBottom ? `var(--spacing-global-space6)` : `0`};
		margin-right: ${marginRight ? `var(--spacing-global-space6)` : `0`};
		position: relative;
		width: ${fullWidth ? `100%` : `fit-content`};
	`}
`;

const StyledRadioInput = styled.input.attrs({
	className: 'fuse-radio__input',
	'data-testid': 'fuse-radio__input',
})`
	appearance: none;
	background: var(--color-global-grey100);
	border: 3px solid var(--color-global-grey100);
	border-radius: 50%;
	cursor: pointer;
	height: ${input.height};
	left: var(--border-width-s); // Offset for outer box-shadow width
	margin: 0;
	box-shadow: 0 0 0 var(--border-width-s) var(--color-functional-divider);
	position: absolute;
	width: ${input.width};

	&:checked {
		background: var(--color-brand-mid);
		box-shadow: 0 0 0 var(--border-width-s) var(--color-brand-mid);
	}

	/* override user agent stylesheet */
	&:focus-visible {
		outline-offset: 0;
	}

	&:focus,
	&:hover {
		outline: none;
		box-shadow: 0 0 0 var(--border-width-s) var(--color-brand-dark);
	}

	&:focus:checked,
	&:hover:checked {
		outline: none;
		background: var(--color-brand-dark);
	}

	&:disabled {
		cursor: default;
		box-shadow: 0 0 0 var(--border-width-s) var(--color-functional-divider);
	}
	&:disabled:checked,
	&:disabled:focus:checked,
	&:disabled:hover:checked {
		background: var(--color-functional-divider);
	}

	&:focus-visible + label {
		${FocusCss}
	}

	&.fuse-radio__input--safari-focus {
		&:focus-within + label {
			${FocusCss}
		}
	}
`;

const StyledRadioLabel = styled(TypographyComponent).attrs({
	className: 'fuse-radio__label',
	'data-testid': 'fuse-radio__label',
})`
	align-items: center;
	display: inline-flex;
	margin: 0;
	cursor: pointer;

	&[disabled] {
		color: var(--color-functional-divider);
		cursor: default;
	}

	/* 
		Used to render empty content in place of input 
		So the focus visible would appear to span the whole radio rather than just label 
	*/
	&::before {
		content: '';
		display: inline-block;
		height: ${radioLabelBefore.height};
		margin-right: var(--spacing-global-space4);
		min-width: ${radioLabelBefore.width};
	}

	${StyledTappableArea}
`;

export { StyledRadio, StyledRadioInput, StyledRadioLabel };
